import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent, isSupported } from "firebase/analytics";

// ---------------------------------------------------------------------------
// Reads config from environment variables (CRA convention). Create a .env
// file at the project root -- see README. Falls back to inline values so you
// can also just paste your existing config object here during migration.
// ---------------------------------------------------------------------------
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "photolevs-c2e30.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "photolevs-c2e30",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "photolevs-c2e30.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

// App Check (your existing setup)

// Analytics – lazy initialised because it requires browser APIs
let analytics = null;
isSupported()
  .then((ok) => {
    if (ok && firebaseConfig.measurementId) analytics = getAnalytics(app);
  })
  .catch(() => {});

/** Fire‑and‑forget analytics that can never break the UI. */
export function track(event, params) {
  try {
    if (analytics) logEvent(analytics, event, params);
  } catch {
    /* no‑op */
  }
}